require('./common')
require('./images/logo.png')
require('./images/radar_legend.png')
require('./analytics.js')

const Factory = require('./util/factory')

const documentId = 'https://raw.githubusercontent.com/bettercaring/tech-radar-quadrants/refs/heads/master/radar.csv'

const urlParams = new URLSearchParams(window.location.search)

if (!urlParams.has('documentId')) {
  window.location.href = `${window.location.origin}?documentId=${documentId}`
} else {
  Factory().build()
  window.history.replaceState({}, document.title, window.location.pathname + window.location.hash)
}
